import LinkPriorWorksheetsForm from './LinkPriorWorksheetsForm';
import { useWorksheets } from '../../queries/use-worksheets';
import { toastNotification } from '../../components/toast/Toast';
import { useEffect } from 'react';
import { Worksheet } from '../../types/worksheet';

type LinkPriorWorksheetsContainerProps = {
    priorWorkpaperId: string;
    selectedWorksheets: Worksheet[];
    accountWorksheets: boolean;
    onLink: (data: { worksheetsLinked: number }) => void;
};

function LinkPriorWorksheetsContainer({
    priorWorkpaperId,
    selectedWorksheets,
    accountWorksheets,
    onLink,
}: LinkPriorWorksheetsContainerProps): JSX.Element {
    const currentWorksheetsQuery = useWorksheets({
        page: 1,
        limit: 1000,
        filterQuery: '',
        searchQuery: '',
        sortQuery: '',
        hasAccount: accountWorksheets,
    });
    const priorWorksheetsQuery = useWorksheets(
        { page: 1, limit: 1000, filterQuery: '', searchQuery: '', sortQuery: '', hasAccount: accountWorksheets },
        priorWorkpaperId
    );

    const isLoading = priorWorksheetsQuery.isLoading || currentWorksheetsQuery.isLoading;
    const isError = priorWorksheetsQuery.isError || currentWorksheetsQuery.isError;

    useEffect(() => {
        if (!isLoading && isError) {
            toastNotification('error', 'Something went wrong. Please try again. Contact us if issue persists');
        }
    }, [isLoading, isError]);

    if (isLoading) {
        return <></>;
    }
    const currentWorksheets = currentWorksheetsQuery.data?.worksheets ?? [];
    const priorWorksheets = (priorWorksheetsQuery.data?.worksheets ?? []).sort((a, b) => ((a.name ?? '') > (b.name ?? '') ? 1 : -1));

    return (
        <>
            <div className="flex items-start justify-between">
                <hgroup className={'text-left'}>
                    <h2 className="text-lg text-gray-900 font-medium">Link Prior Worksheets</h2>
                    <p className="text-sm text-gray-600 max-w-[100ch]">
                        Link worksheets in this workpaper to the corresponding worksheets in the prior workpaper. You do not need to link
                        every worksheet you have selected. When you are happy with the linkings, click &ldquo;Confirm&ldquo;.
                    </p>
                </hgroup>
            </div>

            <hr className="my-4" />
            <LinkPriorWorksheetsForm
                priorWorkpaperId={priorWorkpaperId}
                selectedWorksheets={selectedWorksheets}
                currentWorksheets={currentWorksheets}
                priorWorksheets={priorWorksheets}
                isLoading={isLoading}
                onLink={onLink}
            />
        </>
    );
}
export default LinkPriorWorksheetsContainer;
